module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/export-74bf5a8356a0b43b60b41327e6174863.svg";